export const getConceito = (value) => {
  if (value < 20) {
    return "Ruim"
  } else if (value < 40) {
    return "Baixo"
  } else if (value < 60) {
    return "Médio"
  } else if (value < 80) {
    return "Bom"
  } else {
    return "Alto"
  }
}